// Range slider
console.log("double-range-slider.js loaded");
document.addEventListener("DOMContentLoaded", () =>
{
    const rangeSliders = document.querySelectorAll(".double_range_slider");

    rangeSliders.forEach(rangeSlider => {
        const minRangeValueGap = 1;
        const range = rangeSlider.querySelector(".highlighted_range");
        const minval_number_input = rangeSlider.querySelector(".min_value");
        const maxval_number_input = rangeSlider.querySelector(".max_value");
        const rangeInputs = rangeSlider.querySelectorAll("input[type=range]");
        const rangeNumberInputs = rangeSlider.querySelectorAll("input.range_slider_number");
        
        let minRange, maxRange, minPercentage, maxPercentage;
        
        const minRangeFill = () => {
            const min = parseFloat(rangeInputs[0].min);
            const max = parseFloat(rangeInputs[0].max);
            range.style.left = ((rangeInputs[0].value - min) / (max - min)) * 100 + "%";
        };
        const maxRangeFill = () => {
            const min = parseFloat(rangeInputs[1].min);
            const max = parseFloat(rangeInputs[1].max);
            range.style.right = 100 - ((rangeInputs[1].value - min) / (max - min)) * 100 + "%";
        };
        const setmin_valueOutput = () => {
            minRange = parseInt(rangeInputs[0].value);
            minval_number_input.value = rangeInputs[0].value;
        };
        const setmax_valueOutput = () => {
            maxRange = parseInt(rangeInputs[1].value);
            maxval_number_input.value = rangeInputs[1].value;
        };
        
        setmin_valueOutput();
        setmax_valueOutput();
        minRangeFill();
        maxRangeFill();
        
        rangeInputs.forEach((rangeInput) => {
            rangeInput.addEventListener("input", (e) => {
                setmin_valueOutput();
                setmax_valueOutput();
            
                minRangeFill();
                maxRangeFill();
            
                if (maxRange - minRange < minRangeValueGap)
                {
                    if (e.target.className === "min")
                    {
                        rangeInputs[0].value = maxRange - minRangeValueGap;
                        setmin_valueOutput();
                        minRangeFill();
                        e.target.style.zIndex = "2";
                    }
                    else
                    {
                        rangeInputs[1].value = minRange + minRangeValueGap;
                        e.target.style.zIndex = "2";
                        setmax_valueOutput();
                        maxRangeFill();
                    }
                }
            });
        });

        rangeNumberInputs.forEach((rangeNumberInput) => {
            let rangeSliderInput, adjustSliderTimeout, min_value;
            if (rangeNumberInput==minval_number_input)
            {
                rangeSliderInput = rangeInputs[0];
            }
            else
            {
                rangeSliderInput = rangeInputs[1];
            }
            rangeNumberInput.addEventListener("input", (e) => {
                clearTimeout(adjustSliderTimeout);
                adjustSliderTimeout = setTimeout(() => {
                    rangeSliderInput.value = rangeNumberInput.value;
                    rangeSliderInput.dispatchEvent(new Event('input'));
                },600); 
            });
        });
    });
});